export default "__VITE_ASSET__DGb0vC0s__"